// React libraries
import * as React from 'react';
import classnames from 'classnames';
// Custom Styles
import { useStyles } from "./ListModalStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Modal } from "../../index";
import { GreyButton } from "../../index";
export const ListModal = (props) => {
    const classes = useStyles(props);
    const modalWidth = 285;
    const modalHeight = 350;
    const { isModalOpen, title, data, initialSelected, listTypes } = props;
    return (React.createElement(Modal, { isModalOpen: isModalOpen, width: modalWidth, height: modalHeight },
        React.createElement("div", { className: classes.floatingDiv },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarTop },
                    React.createElement("p", null, title)),
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivContent, style: { height: `calc(${modalHeight}px - 50px - 50px)` } }, data.map((data) => {
                    const floatingDivContentButtonClasses = classnames({
                        [classes.floatingDivContentButton]: true,
                        [classes.floatingDivContentButtonActive]: data === initialSelected,
                    });
                    if (data.alwaysShow) {
                        return (React.createElement(Button, { className: floatingDivContentButtonClasses, style: { color: "#f6891f" }, onClick: () => { props.setInitialSelected(data); props.setOpenModalState(false); } }, data.name));
                    }
                    else if (listTypes) {
                        if (listTypes.includes(data.type)) {
                            return (React.createElement(Button, { className: floatingDivContentButtonClasses, onClick: () => { props.setInitialSelected(data); props.setOpenModalState(false); } },
                                data.name,
                                " ",
                                React.createElement("span", { className: classes.dataDescription }, data.description)));
                        }
                        else {
                            return;
                        }
                    }
                    else {
                        return (React.createElement(Button, { className: floatingDivContentButtonClasses, onClick: () => { props.setInitialSelected(data); props.setOpenModalState(false); } }, data.name));
                    }
                })),
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { onClick: () => props.setOpenModalState(false) }, "Cancel"))))));
};
ListModal.defaultProps = {
    setInitialSelected: () => { },
    setOpenModalState: () => { },
    initialSelected: {}
};
export default React.memo(ListModal);
